import { render, staticRenderFns } from "./OperacaoCliente.vue?vue&type=template&id=292cc2a2"
import script from "./OperacaoCliente.vue?vue&type=script&lang=js"
export * from "./OperacaoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports